import { Link } from 'react-router-dom'
import { useReveal } from '@/hooks/useReveal'

export function CTA() {
  const revealRef = useReveal<HTMLDivElement>()

  return (
    <section className="cta" ref={revealRef}>
      <div className="container">
        <div className="cta-card reveal">
          <div className="cta-bg" aria-hidden="true" />
          <div className="cta-content">
            <h2 className="cta-title">需要增值电信业务服务？</h2>
            <p className="cta-desc">
              了解我们如何为您提供合规、可靠、高效的互联网信息服务与技术支持。
            </p>
            <div className="cta-actions">
              <Link to="/about" className="btn btn-primary btn-lg">
                了解我们
              </Link>
              <Link to="/services" className="btn btn-ghost btn-lg btn-on-accent">
                了解核心服务
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
